import React, { useContext, useEffect, useRef } from "react";
import SubUnitDesignation from "../admin/subUnitDesignation";
import { hasDesignationPermission } from "../admin/adminStrukturaPreduzeca";
import { UserContext } from "../../userContext";
import { MAX_ORG_LEVEL, levelLabel } from "../../constants/orgLevels";

// Rekurzivna podjedinica (nivo 4-6): naziv, radna mesta i deca do
// MAX_ORG_LEVEL nivoa.
export default function SubUnit({
  subUnit,
  subUnits = {},
  department,
  division,
  subdivision,
  activeUnit,
  handleCreateDesignation,
  handleCreateUnit,
  handleDeleteNewUnit,
  value,
  handleAddNewUnit,
  setValue,
  handleChangeNewUnit,
  handleKeyDown,
  handleSetEditUnit,
  handleChangeUnitName,
  handleUpdateUnit,
  handleSetEditDesignation,
  handleChangeDesignationName,
  handleUpdateDesignation,
  handleDeleteDesignation,
  handleDeleteUnit,
  validationError,
  handleSetUnitOpen,
  handleShowDescription,
  showDescription,
  setShowDescription,
  hasOrganizationUnitPermission,
}) {
  function objectNotEmpty(object = {}) {
    return Object.keys(object).length > 0;
  }

  const subUnitRef = useRef();
  const newDesignationRef = useRef();
  const newSubUnitRef = useRef();

  const { user } = useContext(UserContext);

  const filterChildren = (unit) => {
    const children = [];
    Object.keys(subUnits).forEach((key) => {
      if (subUnits[key].parent_sub_unit_id === unit.id) {
        children.push(subUnits[key]);
      }
    });
    return children;
  };

  useEffect(() => {
    if (subUnitRef.current) {
      subUnitRef.current.style.height = "100%";
      const scrollHeight = subUnitRef.current.scrollHeight;
      subUnitRef.current.style.height = scrollHeight + "px";
    }
  }, [subUnit]);

  useEffect(() => {
    if (newDesignationRef.current && value.key === "sub_unit_designation") {
      newDesignationRef.current.style.height = "100%";
      const scrollHeight = newDesignationRef.current.scrollHeight;
      newDesignationRef.current.style.height = scrollHeight + "px";
    }

    if (newSubUnitRef.current && value.key === "sub_unit") {
      newSubUnitRef.current.style.height = "100%";
      const scrollHeight = newSubUnitRef.current.scrollHeight;
      newSubUnitRef.current.style.height = scrollHeight + "px";
    }
  }, [value]);

  return (
    <div>
      <div className="organization-wrapper">
        <div
          className={
            subUnit.id === validationError?.id &&
            validationError?.level === subUnit.level
              ? "input-wrapper unit-error-border"
              : "input-wrapper"
          }
        >
          <img className="department-icon" src="/images/serviceicon.png" />
          <textarea
            ref={subUnitRef}
            autoFocus
            rows="1"
            title={levelLabel(subUnit.level)}
            style={{ resize: "none", overflow: "hidden", marginBottom: "3px" }}
            readOnly={!subUnit.editing && !subUnit.typing}
            type="text"
            className="service-title-input"
            value={subUnit.name}
            onChange={(e) => handleChangeUnitName(e, subUnit.id, "sub_units")}
          ></textarea>

          {hasOrganizationUnitPermission && (
            <div className="edit-department-buttons-block">
              {subUnit.editing && (
                <button onClick={() => handleUpdateUnit(subUnit, subUnit.level)}>
                  <img src="/images/check1.jpg" />
                </button>
              )}
              {!subUnit.editing && (
                <button
                  onClick={() =>
                    handleSetEditUnit(subUnit.id, "sub_units", subUnit.level)
                  }
                >
                  <img src="/images/edit.png" />
                </button>
              )}
              <button
                onClick={() =>
                  handleDeleteUnit(
                    { id: subUnit.id, level: subUnit.level },
                    "unit"
                  )
                }
              >
                <img src="/images/trash.png" />
              </button>
              <div
                className="unfold-list-arrow"
                onClick={() => handleSetUnitOpen(subUnit.id, "sub_units")}
              >
                <img
                  alt=""
                  src={
                    subUnit.isOpen
                      ? "/images/dropdownup.png"
                      : "/images/dropdowndown.png"
                  }
                ></img>
              </div>
            </div>
          )}
        </div>

        {objectNotEmpty(subUnit.designations) && subUnit.isOpen && (
          <ul className="positions-list">
            {Object.keys(subUnit.designations).map((key) => {
              const position = subUnit.designations[key];
              if (!position.del)
                return (
                  <SubUnitDesignation
                    key={`designation${position.id}`}
                    position={position}
                    validationError={validationError}
                    handleChangeDesignationName={handleChangeDesignationName}
                    subUnit={subUnit}
                    setShowDescription={setShowDescription}
                    handleUpdateDesignation={handleUpdateDesignation}
                    handleShowDescription={handleShowDescription}
                    handleSetEditDesignation={handleSetEditDesignation}
                    handleDeleteDesignation={handleDeleteDesignation}
                    showDescription={showDescription}
                    hasDesignationPermission={hasDesignationPermission(
                      user,
                      subUnit.id,
                      subUnit.level
                    )}
                  />
                );
            })}
          </ul>
        )}
        <div>
          {value &&
            value.key === "sub_unit_designation" &&
            value.parent_id === subUnit.id && (
              <div className="new-designation-block">
                <div
                  className={
                    validationError?.adding &&
                    validationError?.key === "sub_unit_designation"
                      ? "new-designation-input-wrapper error-border-bottom"
                      : "new-designation-input-wrapper"
                  }
                >
                  <textarea
                    ref={newDesignationRef}
                    rows="1"
                    autoFocus
                    style={{ resize: "none", overflow: "hidden" }}
                    placeholder="naziv radnog mesta"
                    type="text"
                    className="add-to-list-input"
                    value={value.name}
                    onChange={(e) => handleChangeNewUnit(e, "name")}
                    onKeyDown={(e) =>
                      handleKeyDown(e, handleCreateDesignation, value)
                    }
                  ></textarea>

                  <div className="edit-department-buttons-block">
                    {(value?.adding || value?.editing) && value.name && (
                      <button onClick={() => handleCreateDesignation(value)}>
                        <img src="/images/check1.jpg" />
                      </button>
                    )}
                    {!value?.adding && !value.editing && value.name && (
                      <button>
                        <img src="/images/edit.png" />
                      </button>
                    )}
                    <button onClick={() => handleDeleteNewUnit()}>
                      <img src="/images/trash.png" />
                    </button>
                    <button
                      onClick={() =>
                        setValue((value) => {
                          return {
                            ...value,
                            openDescription: !value.openDescription,
                          };
                        })
                      }
                    >
                      <img
                        alt=""
                        src={
                          value?.openDescription
                            ? "/images/iks.png"
                            : "/images/plus.png"
                        }
                      />
                    </button>
                  </div>
                </div>
                {value.openDescription && (
                  <textarea
                    rows="4"
                    cols="50"
                    className="position-description"
                    placeholder="dodajte opis"
                    value={value.description}
                    onChange={(e) => handleChangeNewUnit(e, "description")}
                  />
                )}
              </div>
            )}
        </div>

        {!subUnit.typing &&
          hasDesignationPermission(user, subUnit.id, subUnit.level) && (
            <button
              disabled={activeUnit}
              className="add-position-button"
              onClick={() =>
                handleAddNewUnit({
                  name: "",
                  key: "sub_unit_designation",
                  description: "",
                  level: subUnit.level,
                  parent_id: subUnit.id,
                  adding: true,
                  openDescription: true,
                })
              }
            >
              <span>
                <img
                  className="plus-circle-icon"
                  src="/images/pluscircle.png"
                />
              </span>
              <span>Dodajte radno mesto</span>
            </button>
          )}

        <div className="add-to-list-block">
          {filterChildren(subUnit)?.length > 0 && subUnit.isOpen && (
            <ul className="odseci-list">
              {filterChildren(subUnit).map((child) => {
                if (!child.del)
                  return (
                    <SubUnit
                      subUnit={child}
                      key={`subUnit${child.id}`}
                      subUnits={subUnits}
                      value={value}
                      handleCreateDesignation={handleCreateDesignation}
                      handleCreateUnit={handleCreateUnit}
                      handleKeyDown={handleKeyDown}
                      setValue={setValue}
                      handleAddNewUnit={handleAddNewUnit}
                      department={department}
                      division={division}
                      subdivision={subdivision}
                      handleSetEditUnit={handleSetEditUnit}
                      handleChangeUnitName={handleChangeUnitName}
                      handleUpdateUnit={handleUpdateUnit}
                      handleSetEditDesignation={handleSetEditDesignation}
                      handleChangeDesignationName={handleChangeDesignationName}
                      handleUpdateDesignation={handleUpdateDesignation}
                      handleDeleteDesignation={handleDeleteDesignation}
                      handleDeleteUnit={handleDeleteUnit}
                      handleDeleteNewUnit={handleDeleteNewUnit}
                      handleChangeNewUnit={handleChangeNewUnit}
                      validationError={validationError}
                      handleSetUnitOpen={handleSetUnitOpen}
                      handleShowDescription={handleShowDescription}
                      showDescription={showDescription}
                      setShowDescription={setShowDescription}
                      activeUnit={activeUnit}
                      hasOrganizationUnitPermission={
                        hasOrganizationUnitPermission
                      }
                    />
                  );
              })}
            </ul>
          )}
          <div>
            {value &&
              value.key === "sub_unit" &&
              value.parent_id === subUnit.id && (
                <div
                  className={
                    validationError?.adding &&
                    validationError?.key === "sub_unit"
                      ? "input-wrapper unit-error-border"
                      : "input-wrapper"
                  }
                  style={{ marginLeft: "20px" }}
                >
                  <img
                    alt=""
                    className="department-icon"
                    src="/images/serviceicon.png"
                  />
                  <textarea
                    ref={newSubUnitRef}
                    autoFocus
                    rows="1"
                    title={levelLabel(value.level)}
                    style={{ resize: "none", overflow: "hidden" }}
                    type="text"
                    className="service-title-input"
                    value={value.name}
                    onChange={(e) => handleChangeNewUnit(e, "name")}
                    onKeyDown={(e) => handleKeyDown(e, handleCreateUnit, value)}
                  ></textarea>

                  <div className="edit-department-buttons-block">
                    {(value?.adding || value?.editing) && value.name && (
                      <button onClick={() => handleCreateUnit(value)}>
                        <img src="/images/check1.jpg" />
                      </button>
                    )}
                    {!value?.adding && !value.editing && value.name && (
                      <button>
                        <img src="/images/edit.png" />
                      </button>
                    )}
                    <button onClick={() => handleDeleteNewUnit()}>
                      <img src="/images/trash.png" />
                    </button>
                  </div>
                </div>
              )}
          </div>

          {subUnit.isOpen &&
            hasOrganizationUnitPermission &&
            subUnit.level < MAX_ORG_LEVEL && (
              <button
                className="add-odsek-button"
                onClick={() =>
                  handleAddNewUnit({
                    name: "",
                    key: "sub_unit",
                    adding: true,
                    parent_id: subUnit.id,
                    department_id: department.id,
                    division_id: division.id,
                    subdivision_id: subdivision.id,
                    level: subUnit.level + 1,
                  })
                }
              >
                + Dodajte podjedinicu
              </button>
            )}
        </div>
      </div>
    </div>
  );
}
